var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"be-author-network"},[(_vm.symbol)?_c('old-tooltip',{attrs:{"label":_vm.tooltip}},[_c('i',{class:_vm.symbol})]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }